import { render, staticRenderFns } from "./showRecoEvent.vue?vue&type=template&id=118aa60f&"
import script from "./showRecoEvent.vue?vue&type=script&lang=js&"
export * from "./showRecoEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports